const customcardTypesReducer = (data = {}, action) => {
    switch(action.type){
        case 'SET_CUSTOMCARD_TYPES':
            data = action.data;
            return data;
        default:
            return data;
    }
}

export default customcardTypesReducer;